/**
 * @fileoverview AgentShield Next.js Integration
 * @version 0.1.0
 * @license MIT OR Apache-2.0
 */

// Export the enhanced middleware that handles initialization internally
export { createAgentShieldMiddleware, createMiddleware } from './create-middleware';

// Export enhanced middleware with built-in features
export {
  createEnhancedAgentShieldMiddleware,
  type EnhancedMiddlewareConfig,
  type StorageAdapter,
  type StorageConfig,
  type AgentDetectionEvent,
  type AgentSession,
} from './enhanced-middleware';

// Also export original middleware for advanced users
export { createAgentShieldMiddleware as createAgentShieldMiddlewareBase } from './middleware';

// Export session tracking utilities
export { EdgeSessionTracker, StatelessSessionChecker } from './session-tracker';
export type { SessionData, SessionTrackingConfig } from './session-tracker';

// Export API-based detection (recommended for production)
export { withAgentShield, agentShieldMiddleware } from './api-middleware';
export type { AgentShieldMiddlewareConfig } from './api-middleware';
export { AgentShieldClient, getAgentShieldClient, resetAgentShieldClient } from './api-client';
export type {
  AgentShieldClientConfig,
  EnforcementAction,
  EnforcementDecision,
  EnforceResponse,
  EnforceInput,
  LogDetectionInput,
} from './api-client';

export * from './types';
// Hooks are not exported from main entry - they're client-only
// If someone needs hooks, they should import from '@kya-os/agentshield-nextjs/hooks'

// Export policy utilities for local policy evaluation
export {
  applyPolicy,
  evaluatePolicyForDetection,
  createContextFromDetection,
  handlePolicyDecision,
  getPolicy,
  buildBlockedResponse as buildPolicyBlockedResponse,
  buildRedirectResponse as buildPolicyRedirectResponse,
  // Re-exports from shared
  evaluatePolicy,
  createEvaluationContext,
  ENFORCEMENT_ACTIONS,
  DEFAULT_POLICY,
} from './policy';
export type {
  PolicyMiddlewareConfig,
  NextJSPolicyMiddlewareConfig,
  PolicyConfig,
  PolicyEvaluationContext,
  PolicyEvaluationResult,
} from './policy';

/**
 * Library version
 */
export const VERSION = '0.1.0';
